export default "__VITE_ASSET__f46a604d__"